import { Component, OnInit, Inject, ViewChild, AfterViewInit, QueryList, ViewChildren } from '@angular/core';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { TranslateService } from '@ngx-translate/core';
import { cloneControl } from 'app/e-form/helper/script/cloneAbstract';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MessageBoxComponent } from 'app/shared/message-box/message-box';
import { NumeralPipe } from 'app/shared/numeral.pipe';
import { MatLegacyMenuTrigger as MatMenuTrigger } from '@angular/material/legacy-menu';
import { HelperTransalaterService } from 'app/e-form/service/helper-translate.service';
import { UUID } from 'app/e-form/helper/script/uuid';
import { ChangeDetectorRef,ChangeDetectionStrategy } from '@angular/core';

@Component({
   changeDetection: ChangeDetectionStrategy.OnPush,
   selector: 'app-form-translate',
   templateUrl: './form-translate.component.html',
   styleUrls: ['./form-translate.component.scss']
})

export class FormTranslateComponent implements OnInit, AfterViewInit {
   displayedColumns = ['lang'];
   _displayIndex = new UUID();
   displayedColumns2 = ['lang'];
   displayedColumns3 = ['lang'];
   currentLang = this.translate.currentLang;
   original = this.data.eForm.controls.original.value;
   langSource = [];
   searchText = [];
   duplicateType = '';
   size = 0; count = 0; page = 0;  matTab = 0;
   menuOpened = false; menuOpened2 = false; menuOpened3 = false; isEdit = false;
   _displayedPageSizeOptions: number[];
   tmpDataSource = [];
   tmpDateSourcePlaceholder = [];
   tmpDateSourceErrorMsg = [];
   langSupport = [];
   private _dynamicIndex = 0;
   tmpEform: FormGroup;
   dataSource = new MatTableDataSource<any>(this.tmpDataSource);
   dataSource2 = new MatTableDataSource<any>(this.tmpDateSourcePlaceholder);
   dataSource3 = new MatTableDataSource<any>(this.tmpDateSourceErrorMsg);
   @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
   @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;
   constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<FormTranslateComponent>,
      private dialog: MatDialog, public translate: TranslateService, private numeral: NumeralPipe,
      private helperTranslater: HelperTransalaterService, private cdr: ChangeDetectorRef) {
   }

   ngOnInit(): void {
      this.initailizeDataSource();
      this.supplyInitsLabels();
      this.supplyInitsPlaceholder();
      this.supplyInitsRgxMessage();
      this.customRoundRobinFilters();
   }

   customRoundRobinFilters() {
      const filterRender = (data: any, filter: string) => {
         let _filteredData: any;
         for (const _column of this.displayedColumns) {
            const _filter = data[_column]?.toLowerCase().includes(filter);
            if (_filter === true) {
               _filteredData = _filter; break;
            } else {
               _filteredData = false;
            }
         }
         return _filteredData;
      };

      this.dataSource.filterPredicate = (data, filter) => filterRender(data, filter);
      this.dataSource2.filterPredicate = (data, filter) => filterRender(data, filter);
      this.dataSource3.filterPredicate = (data, filter) => filterRender(data, filter);
   }

   ngAfterViewInit() {
      this.dataSource.paginator = this.paginator.toArray()[0];
      this.size = this.paginator.toArray()[0].pageSize;
      this.count = this.dataSource.data.length;
      this.page = this.dataSource.paginator.pageIndex;
      this._updateDisplayedPageSizeOptions();
      this._subAssign();
   }

   applyFilter(event: any) {
      const filterValue = (event.target as HTMLInputElement).value;
      if (event.target.id === 'search-group-label') {
         this.dataSource.filter = filterValue.trim().toLowerCase();
         this.count = this.dataSource.filteredData.length;
         this.searchText[0] = filterValue;
      } else if (event.target.id === 'search-group-placeholder') {
         this.dataSource2.filter = filterValue.trim().toLowerCase();
         this.count = this.dataSource2.filteredData.length;
         this.searchText[1] = filterValue;
      } else {
         this.dataSource3.filter = filterValue.trim().toLowerCase();
         this.count = this.dataSource3.filteredData.length;
         this.searchText[2] = filterValue;
      }
   }

   initailizeDataSource() {
      
      this.tmpEform = cloneControl<FormGroup>(this.data.eForm);
      const section = this.tmpEform.get('sections') as FormArray;
      this.createRows(this.tmpEform.get('formName').value, 'formName', -1);
      Object.keys(section.controls[0].value.name).forEach(v => this.langSupport.push(v));
      Object.keys(section.controls).forEach(_sIndex => {
         this.createRows(section.controls[_sIndex], 'section', _sIndex);
         const _field = section.controls[_sIndex].get('fields') as FormArray;
         Object.keys(_field.controls).forEach(_fIndex => {
            this.createRows(_field.controls[_fIndex], 'field', _sIndex, _fIndex, _field.controls[_fIndex].value.fieldName);
         });
      });
      moveItemInArray(this.langSupport, this.langSupport.findIndex(v =>  v === this.original), 0);
   }

   createRows(data: FormControl, type: string, sId: any, fId?: any, fieldName?: string, isFormName?: boolean) {
      const _data = data;
      const _dataArrayLabel = [];
      const _dataArrayPlaceholder = [];
      const _dataArrayErrorMsg = [];
      const adds = (x: any) => + x + 1;
      const hasFieldName = (j) => fieldName === '' ? `Field ${adds(j)}` : fieldName;
      const _preArray = (value: any, lang: string, _type: string, _sId?: number, _fId?: number) => {
         const _prepare  = value;
         Object.assign(_prepare, { lang: lang, type: _type, sId: _sId, fId: _fId});
         return _prepare;
      };
      if (type === 'section') {
         _dataArrayLabel.push(_preArray(_data.value.name, `Section ${adds(sId)}`, type, sId));
         _dataArrayPlaceholder.push(_preArray(_data.value.description, `Section ${adds(sId)}`, type, sId));
      } else if (type === 'field') {
         if (data.value.placeholder) {
            _dataArrayPlaceholder.push(_preArray(_data.value.placeholder, hasFieldName(fId) + ` (Section ${adds(sId)})`, type, sId, fId));
         }
         _dataArrayLabel.push(_preArray(data.value.labelName, hasFieldName(fId) + ` (Section ${adds(sId)})`, type, sId, fId));
         if (data.value.fieldType === 'f-name') {
             if (data.value.title.include) {
               _dataArrayLabel.push(_preArray(_data.value.nameLabel.labelTitle, `Title (Section ${adds(sId)} ${hasFieldName(fId)})`, 'name-labelTitle', sId, fId));
             }
             _dataArrayLabel.push(_preArray(_data.value.nameLabel.labelName, `Name (Section ${adds(sId)} ${hasFieldName(fId)})`, 'name-labelName', sId, fId));
             _dataArrayLabel.push(_preArray(_data.value.nameLabel.labelSurname, `Surname (Section ${adds(sId)} ${hasFieldName(fId)})`, 'name-labelSurname', sId, fId));
             if (data.value.middleName.include) {
               _dataArrayLabel.push(_preArray(_data.value.nameLabel.labelMiddle, `Middle Name (Section ${adds(sId)} ${hasFieldName(fId)})`, 'name-labelMiddle', sId, fId));
             }
             if (data.value.initial.include) {
               _dataArrayLabel.push(_preArray(data.value.nameLabel.labelInitial, `Initial (Section ${adds(sId)} ${hasFieldName(fId)})`, 'name-labelInitial', sId, fId));
             }
         } else if (data.value.fieldType === 'f-address') {
            if (data.value.address1?.include) {
               _dataArrayLabel.push(_preArray(_data.value.addressLabel.labelAddress1, `Address1 (Section ${adds(sId)} ${hasFieldName(fId)})`, 'address-labelAddress1', sId, fId));
             }
             if (data.value.address2?.include) {
               _dataArrayLabel.push(_preArray(_data.value.addressLabel.labelAddress2, `Address2 (Section ${adds(sId)} ${hasFieldName(fId)})`, 'address-labelAddress2', sId, fId));
             }
             if (data.value.province?.include) {
               _dataArrayLabel.push(_preArray(_data.value.addressLabel.labelProvince, `Province (Section ${adds(sId)} ${hasFieldName(fId)})`, 'address-labelProvince', sId, fId));
             }
             if (data.value.district?.include) {
               _dataArrayLabel.push(_preArray(_data.value.addressLabel.labelDistrict, `District (Section ${adds(sId)} ${hasFieldName(fId)})`, 'address-labelDistrict', sId, fId));
             }
             if (data.value.subDistrict?.include) {
               _dataArrayLabel.push(_preArray(_data.value.addressLabel.labelSubDistrict, `Sub-District (Section ${adds(sId)} ${hasFieldName(fId)})`, 'address-labelSubDistrict', sId, fId));
             }
             if (data.value.zipCode?.include) {
               _dataArrayLabel.push(_preArray(_data.value.addressLabel.labelZipcode, `Zipcode (Section ${adds(sId)} ${hasFieldName(fId)})`, 'address-labelZipcode', sId, fId));
             }
             if (data.value.city?.include) {
               _dataArrayLabel.push(_preArray(_data.value.addressLabel.labelCity, `City (Section ${adds(sId)} ${hasFieldName(fId)})`, 'address-labelCity', sId, fId));
             }
             if (data.value.state?.include) {
               _dataArrayLabel.push(_preArray(_data.value.addressLabel.labelState, `State (Section ${adds(sId)} ${hasFieldName(fId)})`, 'address-labelState', sId, fId));
             }
             if (data.value.postal?.include) {
               _dataArrayLabel.push(_preArray(_data.value.addressLabel.labelPostal, `Postal (Section ${adds(sId)} ${hasFieldName(fId)})`, 'address-labelPostal', sId, fId));
             }
             if (data.value.country?.include) {
               _dataArrayLabel.push(_preArray(_data.value.addressLabel.labelCountry, `Country (Section ${adds(sId)} ${hasFieldName(fId)})`, 'address-labelCountry', sId, fId));
             }
          } else if (data.value.fieldType === 'f-textbox' && data.value.isRegex) {
             _dataArrayErrorMsg.push(_preArray(data.value.regexMessage, hasFieldName(fId) + ` (Section ${adds(sId)})`, type, sId, fId));
          }
      } else {
         _dataArrayLabel.push(_preArray(_data, 'Form Name', 'Form'));
      }
      _dataArrayLabel.forEach(v => {
         this.tmpDataSource.push(v);
      });
      _dataArrayPlaceholder.forEach(v => {
         this.tmpDateSourcePlaceholder.push(v);
      });
      _dataArrayErrorMsg.forEach(v => {
         this.tmpDateSourceErrorMsg.push(v);
      });
   }

   saveRegals() {
      let _tmpGroup: FormGroup;
      const _section = this.data.eForm.get('sections') as FormArray;
      const _field = (index: number) => _section.at(index).get('fields') as FormArray;
      const _type = (_source: any) => _source.split('-');
      this.dataSource.data.forEach(_source => {
         if (_source.type === 'section') {
            _tmpGroup = _section.controls[_source.sId].get('name') as FormGroup;
         } else if (_source.type === 'field') {
            _tmpGroup = _field(_source.sId).at(_source.fId).get('labelName') as FormGroup;
         } else if (_source.type.startsWith('name-')) {
            const _tmpPrepare = _field(_source.sId).at(_source.fId).get('nameLabel') as FormGroup;
            _tmpGroup = _tmpPrepare.controls[_type(_source.type)[1]] as FormGroup;
         } else if (_source.type.startsWith('address-')) {
            const _tmpPrepare = _field(_source.sId).at(_source.fId).get('addressLabel') as FormGroup;
            _tmpGroup = _tmpPrepare.controls[_type(_source.type)[1]] as FormGroup;
         } else {
            _tmpGroup = this.data.eForm.get('formName') as FormGroup;
         }
         this.assignSaved(_tmpGroup, _source);
      });
      this.dataSource2.data.forEach(_source2 => {
         if (_source2.type === 'section') {
            _tmpGroup = _section.controls[_source2.sId].get('description') as FormGroup;
         } else {
            _tmpGroup = _field(_source2.sId).at(_source2.fId).get('placeholder') as FormGroup;
         }
         this.assignSaved(_tmpGroup, _source2);
      });
      this.dataSource3.data.forEach(_source3 => {
         _tmpGroup = _field(_source3.sId).at(_source3.fId).get('regexMessage') as FormGroup;
         this.assignSaved(_tmpGroup, _source3);
      });
      this.dialogRef.close(this.isEdit);
   }

   assignSaved(formGroup: FormGroup, tmpSource) {
      this.langSupport.forEach(_column => {
         Object.keys(tmpSource).forEach(_keys => {
            if (_column === _keys && _column !== 'lang' && !_column.startsWith('temp')) {
               const value = tmpSource[_keys] === undefined ? '' : tmpSource[_keys];
               formGroup.get(_column).setValue(value);
            }
         });
      });
   }

   canSelection(value: string): boolean {
      switch (this.matTab) {
         case 0 : return this.displayedColumns.some(v => v === value);
         case 1 : return this.displayedColumns2.some(v => v === value);
         case 2 : return this.displayedColumns3.some(v => v === value);
      }
   }

   supplyInitsLabels() {
      const _notDuplicated = (check) => this.displayedColumns.some(v => v === check);
      const _notOptions = (s) => s !== 'lang' && s !== 'type' && s !== 'sId' && s !== 'fId';
      for (const [lang, value] of Object.entries(this.tmpDataSource)) {
         this.tmpDataSource.forEach(v => {
            Object.keys(v).forEach(s => {
               if (_notOptions(s) && value[s] !== '' && !_notDuplicated(s)) {
                  this.displayedColumns.push(s);
                  return;
               }
            });
         });
      }
      if (!_notDuplicated(this.data.eForm.controls.original.value)) {
         this.displayedColumns.push(this.data.eForm.controls.original.value);
      }
      const _index = this.displayedColumns.findIndex(v =>  v === this.original);
      moveItemInArray(this.displayedColumns, _index , 1);
   }

   supplyInitsPlaceholder() {
      const _notDuplicated = (check) => this.displayedColumns2.some(v => v === check);
      const _notOptions = (s) => s !== 'lang' && s !== 'type' && s !== 'sId' && s !== 'fId';
      for (const [lang, value] of Object.entries(this.tmpDateSourcePlaceholder)) {
         this.tmpDateSourcePlaceholder.forEach(v => {
            Object.keys(v).forEach(s => {
               if (_notOptions(s) && value[s] !== '' && !_notDuplicated(s)) {
                  this.displayedColumns2.push(s);
                  return;
               }
            });
         });
      }
      if (!_notDuplicated(this.data.eForm.controls.original.value)) {
         this.displayedColumns2.push(this.data.eForm.controls.original.value);
      }
      const _index = this.displayedColumns2.findIndex(v =>  v === this.original);
      moveItemInArray(this.displayedColumns2, _index , 1);
   }

   supplyInitsRgxMessage() { // must be sort original first
      const _notDuplicated = (check) => this.displayedColumns3.some(v => v === check);
      const _notOptions = (s) => s !== 'lang' && s !== 'type' && s !== 'sId' && s !== 'fId';
      for (const [lang, value] of Object.entries(this.tmpDateSourceErrorMsg)) {
         this.tmpDateSourceErrorMsg.forEach(v => {
            Object.keys(v).forEach(s => {
               if (_notOptions(s) && value[s] !== '' && !_notDuplicated(s)) {
                  this.displayedColumns3.push(s);
                  return;
               }
            });
         });
      }
      if (!_notDuplicated(this.data.eForm.controls.original.value)) {
         this.displayedColumns3.push(this.data.eForm.controls.original.value);
      }
      const _index = this.displayedColumns3.findIndex(v =>  v === this.original);
      moveItemInArray(this.displayedColumns3, _index , 1);
   }

   addNewLang() {
      const _sourceTemp = [];
      const newIndexCol = this.displayedColumns.length ? this.displayedColumns.length + 1 : 1;
      const _pushTemp = (obj: Object) => {
         for (const key in obj) {
            if (key === this.displayedColumns[1]) {
               _sourceTemp.push(obj[key] === '' ? '' : obj[key]);
            }
         }
      };
      const _tmpColumn = 'temp-' + this._displayIndex.getUUIDV4;
      switch (this.matTab) {
         case 0 : this.displayedColumns.splice(newIndexCol, 0, _tmpColumn);
                  this.dataSource.data.forEach(obj => _pushTemp(obj)); break;
         case 1 : this.displayedColumns2.splice(newIndexCol, 0, _tmpColumn);
                  this.dataSource2.data.forEach(obj => _pushTemp(obj)); break;
         default : this.displayedColumns3.splice(newIndexCol, 0, _tmpColumn);
                   this.dataSource3.data.forEach(obj => _pushTemp(obj)); break;
      }
      this._duplicateRow(_tmpColumn, _sourceTemp);
      this.setEdit();
   }

   selectLangs(newColumn: string, oldColumn, cId) {
      let _newIndex;
      _newIndex = newColumn.startsWith('temp') ? 'temp' + this._dynamicIndex++ : newColumn ;
      switch (this.matTab) {
         case 0 :  this.displayedColumns[cId] = _newIndex;
                   this.dataSource.data.forEach(v => {
                   v[_newIndex] = v[oldColumn];
                   v[oldColumn] = ''; });
                   break;
         case 1 :  this.displayedColumns2[cId] = _newIndex;
                   this.dataSource2.data.forEach(v => {
                   v[_newIndex] = v[oldColumn];
                   v[oldColumn] = ''; });
                   break;
         default : this.displayedColumns3[cId] = _newIndex;
                   this.dataSource3.data.forEach(v => {
                   v[_newIndex] = v[oldColumn];
                   v[oldColumn] = ''; });
                   break;
      }
      this._sortOriginal();
      this.setEdit();
   }

   resetValue(resetLang: string) {
      const _resetSource1 = () => { this.dataSource.data.forEach(obj => {
            for (const key in obj) { if (key === resetLang) { obj[key] = ''; }}}); };
      const _resetSource2 = () => { this.dataSource2.data.forEach(obj => {
            for (const key in obj) { if (key === resetLang) { obj[key] = ''; }}}); };
      const _resetSource3 = () => { this.dataSource3.data.forEach(obj => {
            for (const key in obj) { if (key === resetLang) { obj[key] = ''; }}}); };
      switch (this.matTab) {
         case 0 : _resetSource1(); break;
         case 1 : _resetSource2(); break;
         case 2 : _resetSource3(); break;
      }
      this.setEdit();
   }

   private _deleteAction(resetLang: string) {
      this.resetValue(resetLang);
      switch (this.matTab) {
         case 0 : this.displayedColumns.splice(this.displayedColumns.indexOf(resetLang), 1); break;
         case 1 : this.displayedColumns2.splice(this.displayedColumns2.indexOf(resetLang), 1); break;
         case 2 : this.displayedColumns3.splice(this.displayedColumns3.indexOf(resetLang), 1); break;
      }
      this.setEdit();
      this.cdr.detectChanges();
      return true;
   }

   duplicateRow(langKey, _index) {
      const _indexTemp = _index + 1;
      const _tmpColumn = 'temp-' + this._displayIndex.getUUIDV4;
      const _sourceTemp = [];
      const _pushTemp = (obj: Object) => {
         for (const key in obj) {
            if (key === langKey) {
               _sourceTemp.push(obj[key] === '' ? '' : obj[key]);
            }
         }
      };
      this.duplicateType = langKey;
      switch (this.matTab) {
         case 0 : this.displayedColumns.splice(_indexTemp, 0, _tmpColumn);
                  this.dataSource.data.forEach(obj => _pushTemp(obj)); break;
         case 1 : this.displayedColumns2.splice(_indexTemp, 0, _tmpColumn);
                  this.dataSource2.data.forEach(obj => _pushTemp(obj)); break;
         default : this.displayedColumns3.splice(_indexTemp, 0, _tmpColumn);
                   this.dataSource3.data.forEach(obj => _pushTemp(obj)); break;
      }

      this._duplicateRow(_tmpColumn, _sourceTemp);
      this.setEdit();
   }

   private _duplicateRow(langKey: string, obj: Array<string>) {
      const _reAssign = (index2, v2) => {
         obj.forEach((v, index) => {
            if (index2 === index) { v2[langKey] = v; }
         });
      };
      switch (this.matTab) {
         case 0 : this.dataSource.data.forEach((v2, index2) => _reAssign(index2, v2)); break;
         case 1 : this.dataSource2.data.forEach((v2, index2) => _reAssign(index2, v2)); break;
         default : this.dataSource3.data.forEach((v2, index2) => _reAssign(index2, v2)); break;
      }
   }

   getRangeLabel(): string {
      if (this.count === 0 || this.size === 0) { return `0 of ${this.count}`; }

      const count = Math.max(this.count, 0);
      const offset = this.page * this.size;
      const endIndex = offset < count ? Math.min(offset + this.size, count) : offset + this.size;

      const start = this.numeral.transform(offset + 1);
      const last = this.numeral.transform(endIndex);
      const total = this.numeral.transform(this.count);
      return `${start}–${last} of ${total}`;
   }

   clickItemPerPage(): void {
      if (this._displayedPageSizeOptions.length > 1 && this.count >= this._displayedPageSizeOptions[0]) {
         this.menuTrigger.openMenu();
      }
   }

   localName(lid: string) {
      let _text;
      this.translate.get('eform.lang').subscribe(v => {
         _text = v[lid];
      });
      return _text;
   }

   valueWithLang(label: any, lid: any) {
      let _value;
      for (const [lang, value] of Object.entries(label)) {
         if (lang === lid) {
            _value = value;
         }
      }
      return _value;
   }

   containingTmp() {
      let _boolean = false;
      this.displayedColumns.forEach(v => {
         if (v.startsWith('temp')) {
            _boolean = true;
         }
      });
      this.displayedColumns2.forEach(v => {
         if (v.startsWith('temp')) {
            _boolean = true;
         }
      });
      this.displayedColumns3.forEach(v => {
         if (v.startsWith('temp')) {
            _boolean = true;
         }
      });
      return _boolean;
   }

   setEdit() {
      if (!this.isEdit) { this.isEdit = true; }
   }

   _changePageSize(pageSize: number, index: any) {
      this.paginator.toArray()[index].pageSize = pageSize;
      const startIndex = this.page * this.size;
      const previousPageIndex = this.page;
      this.page = Math.floor(startIndex / pageSize) || 0;
      this.size = pageSize;
      this.paginator.toArray()[index].page.emit({
         previousPageIndex,
         pageIndex: this.page,
         pageSize: this.size,
         length: this.count
      });
     if (this.count <= this.size) { this.paginator.toArray()[index].firstPage(); }
   }

   private _updateDisplayedPageSizeOptions() {

      this._displayedPageSizeOptions = this.dataSource.paginator.pageSizeOptions.slice();

      if (this._displayedPageSizeOptions.indexOf(this.size) === -1) {
         this._displayedPageSizeOptions.push(this.size);
      }

      this._displayedPageSizeOptions.sort((a, b) => a - b);
   }

   paginatorChangeTap(tap: number) {
      switch (tap) {
         case 0 : this.dataSource.paginator = this.paginator.toArray()[0];
                  this.count = this.dataSource.data.length;
                  this.page = this.dataSource.paginator.pageIndex;
                  this.size = this.paginator.toArray()[0].pageSize; break;
         case 1 : this.dataSource2.paginator = this.paginator.toArray()[1];
                  this.count = this.dataSource2.data.length;
                  this.page = this.dataSource2.paginator.pageIndex;
                  this.size = this.paginator.toArray()[1].pageSize; break;
         default : this.dataSource3.paginator = this.paginator.toArray()[2];
                  this.count = this.dataSource3.data.length;
                  this.page = this.dataSource3.paginator.pageIndex;
                  this.size = this.paginator.toArray()[2].pageSize; break;
      }
      this._subAssign();
      this._updateDisplayedPageSizeOptions();
   }

   _subAssign() {
      switch (this.matTab) {
         case 0 : this.dataSource.paginator.page.subscribe(v => {
                  this.size = v.pageSize;
                  this.count = v.length;
                  this.page = v.pageIndex;
         }); break;
         case 1 : this.dataSource2.paginator.page.subscribe(v => {
                  this.size = v.pageSize;
                  this.count = v.length;
                  this.page = v.pageIndex;
         }); break;
         default : this.dataSource3.paginator.page.subscribe(v => {
                  this.size = v.pageSize;
                  this.count = v.length;
                  this.page = v.pageIndex;
         }); break;
      }
      this._updateDisplayedPageSizeOptions();
   }

   delayClose(): void {
      setTimeout(() => {
          this.menuOpened = this.menuOpened === true ? false : false;
          this.menuOpened2 = this.menuOpened2 === true ? false : false;
          this.menuOpened3 = this.menuOpened3 === true ? false : false;
         }, 100);
   }

   check(): boolean {
      switch (this.matTab) {
         case 0 : return this.langSupport.length <= (this.displayedColumns.length - 1);
         case 1 : return this.langSupport.length <= (this.displayedColumns2.length - 1);
         case 2 : return this.langSupport.length <= (this.displayedColumns3.length - 1);
      }
   }

   private _sortOriginal(): void {
      switch (this.matTab) {
         case 0:  const _index1 = this.displayedColumns.findIndex(v => v === this.original);
                  if (_index1 !== -1) { moveItemInArray(this.displayedColumns, _index1, 1); } break;
         case 1:  const _index2 = this.displayedColumns2.findIndex(v => v === this.original);
                  if (_index2 !== -1) { moveItemInArray(this.displayedColumns2, _index2, 1); } break;
         default: const _index3 = this.displayedColumns3.findIndex(v => v === this.original);
                  if (_index3 !== -1) { moveItemInArray(this.displayedColumns3, _index3, 1); } break;
      }
   }

   cancel(): void {
      if (this.containingTmp()) {
         const data = {
            message: this.helperTranslater.getTagEform('msg.aware-containing-cancel-save'),
            ok: {
               color: 'primary',
               label: this.helperTranslater.getTagEform('button.yes'),
               action: () => this._ok()
            },
            close: {
               label: this.helperTranslater.getTagEform('button.no'),
               action: () => true
            }
         };
         this.dialog.open(MessageBoxComponent, { disableClose: true, data });
      } else {
         const data = {
            message: this.helperTranslater.getTagEform('msg.aware-cancel-save'),
            ok: {
               color: 'primary',
               label: this.helperTranslater.getSingleTranslation('create_tasks.save'),
               action: () => this._ok()
            },
            close: {
               label: this.helperTranslater.getTagEform('button.dont-save'),
               action: () => this._close()
            }
         };
         this.isEdit ? this.dialog.open(MessageBoxComponent, { disableClose: true, data }) : this._close();
      }

   }

   save(): void {
      const data = {
         message: this.helperTranslater.getTagEform('msg.aware-containing-cancel-save'),
         ok: {
            color: 'primary',
            label: this.helperTranslater.getTagEform('button.yes'),
            action: () => this._ok()
         },
         close: {
            label: this.helperTranslater.getTagEform('button.no'),
            action: () => true
         }
      };
      this.containingTmp() ? this.dialog.open(MessageBoxComponent, { disableClose: true, data }) : this._ok();
   }

  deleteActions(column): void {
      const data = {
         message: this.helperTranslater.getTagEform('msg.aware-delete-column'),
         ok: {
            color: 'primary',
            label: this.helperTranslater.getTagEform('button.yes'),
            action: () => this._deleteAction(column)
         },
         close: {
            label: this.helperTranslater.getTagEform('button.no'),
            action: () => true
         }
      };
     this.dialog.open(MessageBoxComponent, { disableClose: true, data });
   }

   _ok() {
      this.saveRegals();
      return true;
   }

   _close() {
      this.dialogRef.close(false);
      return true;
   }

   isItemsEmpty(): boolean {
      return this.dataSource3.data.length === 0 || this.dataSource3.filteredData.length === 0;
    }

}
